import { useCallback } from 'react'
import Link from 'next/link'

interface Props {
  path: string
  changeTitle?: string
}

export const BreadCrumb = ({ path }: Props) => {
  const blackList = ['/fornecedores']

  const createLink = useCallback(
    ({
      slug,
      text,
      complement
    }: {
      slug: string
      text?: string
      complement?: string
    }) => {
      if (blackList.some(_slug => _slug === slug)) {
        return <></>
      }

      const title = text || slug.toUpperCase().replace(/-/g, ' ')
      return (
        <Link href={slug} key={slug}>
          {title}
          {complement}
        </Link>
      )
    },
    [blackList]
  )

  if (!path) {
    return <></>
  }

  const slugs = path.split('/')
  const links = slugs.map((slug, index) => {
    if (index === 0) {
      return slug
    }

    return slugs.slice(0, index + 1).join('/')
  })

  return (
    <div className="text-orange">
      <Link href={'/'}>PORTAL SOLAR</Link>
      {links.map((slug, index) => (
        <span key={slug}>
          {createLink({
            slug,
            text: slugs[index].toUpperCase().replace(/-/g, ' '),
            complement: index !== links.length - 1 && ' / '
          })}
        </span>
      ))}
    </div>
  )
}
